export interface IBusLocation {
  busStopId: number;
  busStopName: string;
}

export interface IBusItem {
  busId: string;
  busName: string;
  source: string;
  destination: string;
  scheduleTime: string;
  arrival: string;
  busType: string;
  busRouteMappingId: string;
  price: number;
  seatsAvailable: number;
  journeyTime: number;
}

export interface SeatAvailability {
  seatNumber: number;
  isAvailable: boolean;
  isBooked: boolean;
  deskBlocked?: boolean;
  isLadiesSeat: boolean;
  isLadiesOnlyAvailable?: boolean;
  isSelected?: boolean;
  price: number;
  discountPrice?: number;
}

export interface IBookingItem {
  name: string;
  age: number;
  isLadiesSeat: boolean;
  isLadiesOnlyAvailable?: boolean;
  seatNumber: number;
  isSleeperSeat:boolean;
  gender: Gender | '';
  seatPrice?: number
}

export enum Gender {
  MALE= 'MALE',
  FEMALE= 'FEMALE',
}

export interface IBusLayout {
  seatStyle: SEAT_STYLE;
  isAc: boolean;
  seatLayout: SEAT_LAYOUT;
  seatingSeats: SeatAvailability[];
  sleepingSeats: SeatAvailability[];
  isSingleFirstSeats: boolean;
  onToggleSeats: (seats: SeatAvailability[]) => void;
  onToggleSleepers: (seats: SeatAvailability[]) => void;
}

export interface IBookingDetails {
  busId: string;
  busRouteMappingId: string;
  fromStation: string;
  toStation: string;
  bookingDate: string;
  bookingPrice: number;
  travellers: IBookingItem[];
  mobileNumber: string;
}

export enum SEAT_STYLE {
  SEATING = "SEATING",
  SLEEPER = "SLEEPER",
  SEATING_AND_SLEEPER = "SEATING_AND_SLEEPER",
}

export enum SEAT_LAYOUT {
  SINGLE_LAYER_SEATING_2X2 = "SINGLE_LAYER_SEATING_2X2",
  SINGLE_LAYER_SEATING_3X2 = "SINGLE_LAYER_SEATING_3X2",
  TWO_LAYER_SEATING_3X2_SLEEPING_2X1 = "TWO_LAYER_SEATING_3X2_SLEEPING_3X2",
  TWO_LAYER_SEATING_2X2_SLEEPING_1X1 = "TWO_LAYER_SEATING_2X2_SLEEPING_1X1",
  TWO_LAYER_SEATING_2X2_SLEEPING_1X2 = "TWO_LAYER_SEATING_2X2_SLEEPING_2X1",
  TWO_LAYER_SEATING_2X1_SLEEPING_1X1 = "TWO_LAYER_SEATING_2X1_SLEEPING_1X1",
  TWO_LAYER_SEATING_1X2_SLEEPING_1X2 = "TWO_LAYER_SEATING_1X2_SLEEPING_1X2",
  TWO_LAYER_SEATING_2X1_SLEEPING_2X1 = "TWO_LAYER_SEATING_2X1_SLEEPING_2X1",
  TWO_LAYER_SLEEPING_2X1 = "TWO_LAYER_SLEEPING_2X1",
}

export interface IBookedTicket {
  busRouteMappingId: string;
  busSetaId: string;
  bookingRefId: string;
  scheduledRunDate: string;
  bookingDate: string;
  bookingStatus: string |null;
  bookedBy: string;
  cancelDate: string | null;
  bookingPrice: number;
  mobileNumber: string;
  fromStation: string;
  toStation: string; 
  passangerName: string;
  passengerAge: number;
  passengerGender: string;
  bookingId: string;
  busSeatNumber: string;
}

export interface IBookedTicketList {
  busBookingDetailList: IBookedTicket[];
  totalRecords?: number;
}

export interface ICancelStatus {
  bookingId: string;
  isCancelled: boolean;
  cancelMessage: string;
}